
// Hardcoded restrictions configuration
export interface RestrictionSetting {
  type: string; // Keep for backward compatibility with existing code
  name: string; // Human-readable name
  backend_name: string; // Apple Developer documentation key
  parent_id?: string;
  description?: string; // Optional description shown in parentheses
}

export const HARDCODED_RESTRICTIONS: RestrictionSetting[] = [
  {
    type: "airdrop",
    name: "AirDrop",
    backend_name: "allowAirDrop"
  },
  {
    type: "siri",
    name: "Siri",
    backend_name: "allowAssistant"
  },
  {
    type: "siri_profanity_filter",
    name: "Siri Profanity Filter",
    backend_name: "forceAssistantProfanityFilter",
    parent_id: "siri"
  },
  {
    type: "siri_suggestions",
    name: "Siri Suggestions",
    backend_name: "allowSpotlightInternetResults",
    parent_id: "siri"
  },
  {
    type: "siri_user_content",
    name: "Siri User Generated Content",
    backend_name: "allowAssistantUserGeneratedContent",
    parent_id: "siri"
  },
  {
    type: "apple_watch",
    name: "Apple Watch",
    backend_name: "allowPairedWatch"
  },
  {
    type: "imessage",
    name: "iMessage",
    backend_name: "allowChat"
  }
];

export const getHardcodedRestrictions = (): RestrictionSetting[] => {
  return HARDCODED_RESTRICTIONS;
};

export const getHardcodedRestrictionById = (id: string): RestrictionSetting | undefined => {
  return HARDCODED_RESTRICTIONS.find(r => r.type === id);
};
